import IncidentSeveritiesAtAGlanceGraph from './IncidentSeveritiesAtAGlanceGraph';

export default IncidentSeveritiesAtAGlanceGraph;
